module.exports = __webpack_public_path__ + "static/media/firmingelixir.6ad1ee6a.png";